import { render, staticRenderFns } from "./fill-extrusion-picker.vue?vue&type=template&id=d23dc7a4"
import script from "./fill-extrusion-picker.vue?vue&type=script&lang=js"
export * from "./fill-extrusion-picker.vue?vue&type=script&lang=js"
import style0 from "./fill-extrusion-picker.vue?vue&type=style&index=0&id=d23dc7a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports